import { useApi } from '@/api';
import { KpiCard, KpiSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex } from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';

export default function OverviewKpis({ daysAgo }) {
  const [data, error] = useApi({
    url: '/groups/stablecoins/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Flex flexDirection="column" gap="m">
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            variant="usdc"
            title="Reserves"
            data={data}
            field="reserves"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: tokensMapping('USDC'),
                  iconSize: '4'
                }
              }
            }}
          />
          <KpiCard
            title="Total Debt"
            variant="dai"
            data={data}
            field="debt"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: tokensMapping('DAI'),
                  iconSize: '4'
                }
              }
            }}
          />
        </Flex>

        <HistoricTabs />
      </Flex>
    );
  }

  return <KpiSkeleton />;
}
